import React from 'react';
import { Link } from 'react-router-dom';

const MenuMobileAboutEsEs = ({toggleMenuType}) => {
  return (
    <menu>
      <li>
        <span className="arrow-down">A Guararapes</span>
      </li>
      <li className="small">
        <Link to="/a-guararapes/historia">Historia</Link>
      </li>
      <li className="small">
        <Link to="/a-guararapes/manifesto">Manifiesto</Link>
      </li>
      <li className="small">
        <Link to="/a-guararapes/quem-somos">Quienes somos</Link>
      </li>
      <li className="small">
        <Link to="/a-guararapes/unidades">Unidades de negocios</Link>
      </li>
      <li className="small">
        <Link to="/a-guararapes/">Responsabilidades</Link>
      </li>
      <li>
        <span className="arrow-left" onClick={ (e) => { toggleMenuType('regular') }}>Vuelve</span>
      </li>
    </menu>
  )
}
          
export default MenuMobileAboutEsEs;